// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BannerImage_wrapper__y_EvP"};